export const iconFontAwesomeHumanitarianSailboat = (
	<i className="fa-solid fa-sailboat"></i>
);
